// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"597":"6a8e0a1d","715":"eaa28716"}[chunkId] + ".chunk.js";
};